import AreaMapPage from "./AreaMapPage";

export default AreaMapPage;
